import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allgemeines-und-ansprech-partner',
  templateUrl: './allgemeines-und-ansprech-partner.component.html',
  styleUrls: ['./allgemeines-und-ansprech-partner.component.scss']
})
export class AllgemeinesUndAnsprechPartnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
